import { Header } from "../components/Header";
import { Marquee } from "../components/Marquee";
import { Numbers } from "../components/Numbers";
import { Hero } from "../components/Hero";
import { Metodo } from "../components/Metodo";
import { Sobre } from "../components/Sobre";
import { Estrutura } from "../components/Estrutura";
import { Faq } from "../components/Faq";
import { Contato } from "../components/Contato";
import { Footer } from "../components/Footer";
import { WhatsAppFloat, CookieBanner } from "../components/Chrome";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Numbers />
        <Metodo />
        <Sobre />
        <Estrutura />
        <Faq />
        <Contato />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CookieBanner />
    </div>
  );
}
